<script setup lang="ts">
import type { BrokerProfileCardSectionProps } from '.';

import { useAgentProfileStore } from '~/store/agentProfileStore';
import { storeToRefs } from 'pinia';

import { BrokerProfileCard } from '~/components/BrokerProfileCard';

const props = withDefaults(defineProps<BrokerProfileCardSectionProps>(), {
	isLoading: false
});

const emit = defineEmits<{
	(e: 'contactClick'): void;
}>();

const { profile, company } = storeToRefs(useAgentProfileStore());

const agentPictureSrc = computed(
	() =>
		profile.value?.profilePicture?.croppedUrl ||
		profile.value?.profilePicture?.url ||
		''
);
const hasContent = computed<boolean>(() => Boolean(profile.value));

defineExpose({ hasContent });
</script>

<template>
	<BrokerProfileCard
		v-if="profile || isLoading"
		:class="props.class"
		:is-loading="isLoading"
		:agent-name="profile?.name"
		:agent-picture-src="agentPictureSrc"
		:agent-creci="profile?.creci"
		:company-name="company?.name"
		:company-logo-src="company?.smallLogo"
		:company-creci="company?.creci"
		@contact-click="emit('contactClick')"
	/>
</template>
